import React from 'react';
import { Navigate } from 'react-router-dom';
import { Home } from './components/Home';
import { ElectionComponent } from './components/election/ElectionComponent';
import { NotFound } from './components/NotFound';
import { PartyComponent } from './components/party/PartyComponent';
import { CandidateComponent } from './components/candidate/CandidateComponent';
import { ElectionCandidatesScreen } from './components/candidateSystem/ElectionCandidatesScreen';
import { BlankVoteComponent } from './components/BlankVoteComponent';
import { Admin } from './components/Admin';
import { ElectionEditor } from './components/election/ElectionEditor';
import { VoterImport } from './components/Import';
import { VotingResult } from './components/VotingResult';
import { ElectionHistory } from './components/ElectionHistory';
import { CandidateEditComponent } from './components/editCandidate/CandidateEditComponent';
import { PartyEditComponent } from './components/editParty/PartyEditComponent';
import { AccountState } from './_generatedTypes.g';

export const allRoutes = (account: AccountState | null, overrideEnableCandidateEdit: boolean) =>
    [
        { path: "/election/:electionId/candidates", element: <ElectionCandidatesScreen /> },
        { path: "/election/:electionId", element: <ElectionComponent /> },
        { path: "/party/:partyId", element: <PartyComponent /> },
        account?.IsAdmin || account?.IsPartyAdmin ? { path: "/partyEdit/:partyId", element: <PartyEditComponent /> } : {},
        { path: "/candidate/:candidateId", element: <CandidateComponent /> },
        account?.IsAdmin || account?.IsPartyAdmin || account?.IsCandidate || overrideEnableCandidateEdit ? { path: "/candidateEdit/:candidateId", element: <CandidateEditComponent /> } : {},
        { path: "/blankvote/:electionId", element: <BlankVoteComponent /> },
        account?.IsAdmin ? { path: "/admin", element: <Admin /> } : {},
        account?.IsAdmin ? { path: "/electioneditor/:electionId", element: <ElectionEditor /> } : {},
        { path: "/conextlogin", element: <Navigate replace to="/" /> },
        { path: "/emaillogin", element: <Navigate replace to="/" /> },
        { path: "/emailloginlocal", element: <Navigate replace to="/" /> },
        { path: "/", element: <Home /> },
        account?.IsAdmin ? { path: "/votingRightsAdminManagement/", element: <VoterImport /> } : {},
        account?.IsAdmin ? { path: "/votingResult/:electionId", element: <VotingResult /> } : {},
        account?.IsAdmin ? { path: "/electionHistory", element: <ElectionHistory /> } : {},
        { path: "*", element: <NotFound /> },
    ];
    
